/* Últimos días antes de que suban los precios (snippets/ba-ultimos-dias.liquid y la barra de anuncios).
   Un solo reloj para todas las cuentas de la página. Busca los elementos EN CADA TICK, no una vez:
   el cajón del carrito se repinta con la Section Rendering API y un reloj guardado al cargar
   se quedaría mirando nodos que ya no existen.
   Al llegar a la fecha esconde la caja entera: Shopify cachea la página, así que el Liquid puede
   haberla pintado minutos antes del cierre. Nunca se reinicia por visitante (SIC). */
(function () {
  function z(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s %= 86400;
    var h = Math.floor(s / 3600); s %= 3600;
    var m = Math.floor(s / 60); s %= 60;
    return d + 'd ' + z(h) + ':' + z(m) + ':' + z(s);
  }
  function tick() {
    var ahora = Date.now();
    document.querySelectorAll('[data-ba-cuenta]').forEach(function (el) {
      var fin = Date.parse(el.getAttribute('data-fin'));
      if (!isNaN(fin)) el.textContent = fmt(fin - ahora);
    });
    document.querySelectorAll('[data-ba-cuenta-caja]').forEach(function (caja) {
      var fin = Date.parse(caja.getAttribute('data-fin'));
      if (!isNaN(fin) && fin <= ahora) caja.style.display = 'none';
    });
  }
  tick();
  setInterval(tick, 1000);
})();
